const translation = {
  errorBoundary: {
    title: 'Une erreur est survenue',
    description: 'Cette page n\'a pas pu être affichée. Vos données n\'ont pas été modifiées. Réessayez ou rechargez la page.',
    offlineTitle: 'Nous ne parvenons pas à joindre la plateforme',
    offlineDescription: 'La connexion à la plateforme a échoué. Vérifiez votre connexion internet et réessayez.',
    retry: 'Réessayer',
    reload: 'Recharger la page',
  },
  notifications: {
    empty: 'Aucune nouvelle notification',
    clearAll: 'Tout effacer',
    clearAllConfirm: 'Effacer toutes les notifications ? Cette action est irréversible.',
    clearAllFailed: 'Impossible d\'effacer les notifications',
    markReadFailed: 'Impossible de marquer la notification comme lue',
    delete: 'Supprimer la notification',
    deleteFailed: 'Impossible de supprimer la notification',
    reminderTitle: 'Mesure bientôt à effectuer',
    reminderBody: 'Il est presque temps d\'enregistrer {{measurement}} pour {{programme}}.',
    cleared: 'Notifications effacées',
    deleted: 'Notification supprimée',
  },
  dataGrid: {
    noResultsFound: 'Aucun résultat trouvé',
    selectAll: 'Tout sélectionner',
    selectRow: 'Sélectionner {{name}}',
    rowLabel: 'ligne {{id}}',
    ascending: 'Croissant',
    descending: 'Décroissant',
    sortByColumn: 'Trier par {{column}} ({{direction}})',
  },
  manageUsers: {
    title: 'Membres de l\'organisation',
    subtitle: 'Les personnes de votre organisation, et leur rôle ici.',
    nameColumn: 'Nom',
    emailColumn: 'E-mail',
    rolesColumn: 'Rôles',
    rolesPlaceholder: 'Ajouter un rôle',
    rolesSaved: 'Rôles mis à jour',
    rolesFailed: 'Les rôles n\'ont pas pu être mis à jour',
    filterLabel: 'Rôle',
    filterAll: 'Tous les rôles',
    filterNone: 'Sans rôle',
    noTenantNotice: 'Les membres sont listés par organisation, et ce compte n’appartient à aucune.',
    noTenantTitle: 'Pas encore d’organisation',
  },
  navGroups: {
    general: 'Général',
    programmes: 'Programmes',
    mySettings: 'Paramètres',
  },
  navigation: {
    ownEnvironment: 'Mon propre espace',
    platformEnvironment: 'Administration de la plateforme',
    switchEnvironment: 'Changer d\'espace',
    manageUsers: 'Membres de l\'organisation',
    manageRoles: 'Rôles',
    dataPermissions: 'Autorisations de données',
    dataProviders: 'Sources de données',
    adminDataProviders: 'Tous les serveurs FHIR',
    dashboard: 'Mon Tableau de Bord',
    foodTracking: 'Suivi Alimentaire',
    activity: 'Activité',
    sleep: 'Sommeil',
    weightBmi: 'Poids/IMC',
    wellnessValues: 'Valeurs de Bien-être',
    progress: 'Progrès',
    insights: 'Insights',
    myCommunity: 'Ma Communauté',
    coaches: 'Coachs',
    coaching: 'Accompagnement',
    programs: 'Programmes',
    researchData: 'Données de Recherche',
    education: 'Éducation',
    analytics: 'Analytiques',
    billing: 'Facturation',
    masterData: 'Gestion des Données',
    settings: 'Langue et région',
    profile: 'Mon Profil',
    logout: 'Déconnexion',
    uploadPDF: 'Téléverser PDF',
    savedDocuments: 'Mes Documents',
    pinSidebar: 'Épingler la barre',
    unpinSidebar: 'Désépingler la barre',
  },
  devLogin: {
    subtitle: 'Développement local — authentification contournée',
    roles: {
      globalAdmin: 'Admin global',
      tenantAdmin: 'Admin du tenant',
      coach: 'Coach',
      member: 'Membre',
      remoteMember: 'Membre distant',
    },
  },
  brand: {
    loading: 'Chargement',
  },
  auth: {
    platformName: 'My Lifestyle Platform',
    poweredBy: 'propulsé par Stichting Je Leefstijl Als Medicijn',
    platformLogin: 'Connexion à la Plateforme',
    password: 'Mot de passe',
    signIn: 'Se connecter',
    signUp: 'S\'inscrire',
    forgotPassword: 'Mot de passe oublié?',
    requestAccess: 'Demander l\'accès',
    demoMode: 'Mode Démo - Utilisez n\'importe quelles informations d\'identification',
    demoDescription: 'Accédez à votre tableau de bord complet de bien-être lifestyle',
    loginSuccess: 'Connexion réussie! Redirection...',
    sessionExpired: {
      title: 'Votre session a expiré',
      message: 'Pour protéger vos données, vous avez été déconnecté automatiquement. Reconnectez-vous pour continuer.',
      signIn: 'Se reconnecter',
      dismiss: 'Plus tard',
    },
  },
  dashboard: {
    refreshData: 'Actualiser les données',
    lastSynced: 'Dernière synchronisation {{time}}',
    justSynced: 'Tout juste synchronisé',
    signInRequired: 'Vous devez être connecté pour voir le tableau de bord.',
    unableToLoad: 'Impossible de charger les données du tableau de bord.',
    activeProgrammes: 'Programmes Actifs',
    programmes: 'Programmes',
    trackedMeasurements: 'Mesures suivies',
    targetsConfigured: 'Objectifs configurés',
    dateAxisLabel: 'Date',
    measurementTrends: 'Tendances de mesure',
    measurementTrendsSubtitle: 'Vue empilée pour explorer toutes les mesures ensemble.',
    timeRange: 'Plage de temps :',
    oneYear: '1 an',
    days: '{{count}}j',
    noMeasurementData: 'Pas encore de données de mesure',
    noMeasurementDataSubtitle: 'Lorsque de nouveaux points de données arrivent, la chronologie se met à jour automatiquement.',
    programmeTargets: 'Objectifs du programme',
    programmeTargetsSubtitle: 'Les objectifs sont définis par votre administrateur de programme et affichés ici à titre de référence.',
    noProgrammeMeasurements: 'Aucune mesure de programme disponible pour le moment.',
    latestValue: 'Dernière valeur',
    targetRange: 'Plage cible',
    noMeasurementRecorded: 'Aucune mesure enregistrée pour le moment',
    onTarget: 'Dans la cible',
    needsAttention: 'Nécessite attention',
    noTargetSet: 'Aucun objectif défini',
    min: 'Min : {{value}} {{unit}}',
    max: 'Max : {{value}} {{unit}}',
    rangeTarget: '{{min}} - {{max}} {{unit}}',
    scopeFrom: 'Afficher les mesures à partir du',
    scopeTo: 'Afficher les mesures jusqu’au jour indiqué inclus',
    saved: 'Votre disposition est enregistrée.',
    settingsSaved: '{{name}} est enregistré.',
    deleted: '{{name}} a été supprimé.',
  },
  profile: {
    welcomeNewUser: 'Bienvenue! Veuillez compléter votre profil',
    newUserMessage: 'Aidez-nous à personnaliser votre expérience en remplissant vos informations ci-dessous.',
    continueToDashboard: 'Continuer vers le Tableau de Bord',
    myProfile: 'Mon Profil',
    reviewDetails: 'Consultez et mettez à jour vos informations personnelles',
    completeProfile: 'Complétez votre profil',
    keepUpdated: 'Gardez vos informations à jour pour de meilleures perspectives personnalisées',
    accountInformation: 'Informations du Compte',
    referenceCode: 'Code de Référence',
    anonymousSharingId: 'Votre ID de partage anonyme',
    activeSince: 'Actif depuis',
    personalDetails: 'Détails Personnels',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    nickname: 'Surnom',
    nicknamePlaceholder: 'Comment aimeriez-vous être appelé?',
    birthDate: 'Date de naissance',
    gender: 'Genre',
    genderMale: 'Masculin',
    genderFemale: 'Féminin',
    genderPrefernottosay: 'Préfère ne pas dire',
    emailAddress: 'Adresse E-mail',
    emailPlaceholder: 'votre.email@exemple.com',
    emailHelper: 'Adresse e-mail pour les mises à jour et notifications',
    aboutMe: 'À Propos de Moi',
    headline: 'Titre',
    headlinePlaceholder: 'Un court slogan sur vous',
    bio: 'Biographie',
    bioPlaceholder: 'Parlez-nous un peu de vous',
    motivation: 'Motivation',
    motivationPlaceholder: 'Qu\'est-ce qui vous motive à utiliser cette plateforme?',
    privacyDataSharing: 'Confidentialité et Partage de Données',
    sharingPreference: 'Préférence de Partage',
    sharingHelper: 'Choisissez comment vous souhaitez partager vos données sur cette plateforme',
    shareAnonymously: 'Partager mes données de manière anonyme',
    shareWithName: 'Partager mes données avec mon nom',
    doNotShare: 'Ne pas partager mes données',
    notificationPreferences: 'Préférences de Notification',
    pushNotifications: 'Notifications push',
    pushNotificationsDesc: 'Recevoir des notifications push sur votre appareil',
    emailNotifications: 'Notifications par e-mail',
    emailNotificationsDesc: 'Recevoir des notifications par e-mail',
    inAppNotifications: 'Notifications dans l\'application',
    inAppNotificationsDesc: 'Recevoir des notifications dans l\'application',
    programmeNotifications: 'Notifications de programme',
    programmeNotificationsHelper: 'Choisissez, par programme, combien de minutes avant une mesure programmée vous souhaitez être rappelé. Désactivez les notifications d\'un programme pour arrêter complètement ses rappels.',
    reminderTime: 'Délai de rappel',
    reminderTimeCustomLabel: 'Minutes (1 à 180)',
    reminderNoScheduledMeasurements: 'Ce programme n\'a pas encore de mesures programmées.',
    notificationsLabel: 'Notifications',
    reminderLoadFailed: 'Impossible de charger les paramètres de rappel',
    saving: 'Enregistrement...',
    saveProfile: 'Enregistrer le Profil',
    saveSuccess: 'Profil enregistré avec succès',
    errorLoading: 'Échec du chargement du profil',
    errorSaving: 'Échec de l\'enregistrement du profil',
  },
  uploadPDF: {
    title: 'Téléverser un document',
    description: 'Vous pouvez téléverser vos fichiers PDF ici.',
    documentType: 'Type de document',
    selectDocumentType: 'Sélectionnez le type de document',
    labTest: 'Analyse de laboratoire',
    insuranceDocument: 'Document d\'assurance',
    idCard: 'Carte d\'identité',
    enabledAIExtraction: 'Activé : nous extrairons les observations après le téléversement.',
    disabledAIExtraction: 'Désactivé : nous stockerons uniquement le document.',
    descriptionTitle: 'Description',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'ex. : Analyse sanguine de la visite chez le médecin (24/01/2026)',
    filenameTitle: 'Nom du fichier',
    filenameLabel: 'Nom du fichier',
    filenamePlaceholder: 'Saisissez un nom de fichier',
    filenameRequired: 'Veuillez saisir un nom de fichier.',
    aiExtractionTitle: 'Extraction IA',
    aiExtractionSelectTypeHelper: 'Sélectionnez un type de document pour voir les options d\'extraction IA.',
    dropFilesPrompt: 'Déposez les fichiers ici, ou sélectionnez-les depuis votre appareil',
    chooseFiles: 'Choisir le(s) fichier(s)',
    deleteDocument: 'Effacer la sélection',
    filesSelected: 'fichier sélectionné',
    uploadButton: 'Téléverser',
    documentSuccessfullyUploaded: 'Document téléversé avec succès.',
    aiExtractionNotAvailable: 'L\'extraction IA n\'est pas disponible pour ce type de document',
  },
  savedDocuments: {
    fileName: 'Nom du fichier',
    fileType: 'Type de fichier',
    uploadedBy: 'Televerse par',
    description: 'Description',
    uploadDate: 'Date de téléchargement',
    status: 'Statut',
    inProgress: 'En cours',
    readyForReview: 'Prêt pour révision',
    committed: 'Engagé',
    inReview: 'En révision',
    uploaded: 'Téléchargé',
    failed: 'Échoué',
    unknownStatus: 'Échoué',
    noStatus: 'Aucun statut',
    noDocuments: 'Aucun document trouvé',
    yourDocuments: 'Vos documents',
    viewPreviouslyUploaded: 'Voir les documents précédemment téléversés',
    documents: 'Documents',
    filter: 'Filtrer',
    allTypes: 'Tous',
    preview: 'Aperçu',
    uploadNewDocument: 'Téléverser un nouveau document',
    review: 'Examiner',
    delete: 'Supprimer',
    updateDocument: 'Mettre à jour le document',
    update: 'Mettre à jour',
    cancel: 'Annuler',
    save: 'Enregistrer',
    documentSuccessfullyDeleted: 'Document supprimé avec succès',
    deleteError: 'Erreur lors de la suppression du document',
    deleteErrorPartial_one: '{{count}} document n\'a pas pu être supprimé',
    deleteErrorPartial_other: '{{count}} documents n\'ont pas pu être supprimés',
    downloadError: 'Échec du téléchargement du document',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer {{count}} document(s) ?',
    deleting: 'Suppression...',
    close: 'Fermer',
    download: 'Télécharger',
    types: {
      bloodTestReport: 'Rapport d\'analyse de sang',
      stoolTestReport: 'Rapport d\'analyse des selles',
      consultationNote: 'Note de consultation',
    },
    updateSuccess: 'Document mis à jour',
    updateError: 'Le document n\'a pas pu être mis à jour',
  },
  documentExtractionReview: {
    aiChip: 'TRPI propulsé par IA',
    title: 'Revue d\'extraction',
    previewTitle: 'Aperçu du document',
    preview: {
      loadingDocument: 'Chargement du document...',
      preparingPdf: 'Préparation du PDF...',
      zoom: 'Zoom {{percent}}%',
      zoomControlsAria: 'Contrôles de zoom',
      zoomOut: 'Réduire',
      fit: 'Ajuster',
      zoomIn: 'Agrandir',
      fullscreen: 'Plein écran',
      exitFullscreen: 'Quitter le plein écran',
      unavailable: 'L\'aperçu intégré n\'est pas disponible pour ce fichier. Téléchargez-le pour le consulter.',
      pageOf: 'Page {{current}} sur {{total}}',
      prevPageAria: 'Page précédente',
      nextPageAria: 'Page suivante',
    },
    subtitle: 'Vérifiez les valeurs extraites avant de les valider dans vos observations principales.',
    committedInfo: 'Ce document ne peut plus être modifié, mais vous pouvez toujours consulter les valeurs extraites.',
    commit: {
      action: 'Valider dans le noyau',
      committed: 'Validé',
      aria: 'Valider les mesures extraites',
      success: 'Document validé',
      error: 'Échec de la validation du document',
    },
    tooltips: {
      download: 'Télécharger',
      fullscreen: 'Plein écran',
      exitFullscreen: 'Quitter le plein écran',
    },
    aria: {
      download: 'Télécharger le document',
      fullscreen: 'Basculer le plein écran du panneau droit',
    },
    updatedAt: 'Mis à jour : {{date}}',
    failedMessage: 'L\'extraction a échoué. Vous pouvez toujours prévisualiser le document. Contactez le support si le problème persiste.',
    loadDataError: 'Erreur lors du chargement des données extraites. Veuillez réessayer.',
    extractionInProgress: 'L\'extraction est en cours.',
    notExtracted: 'Non extrait',
    timeline: {
      button: 'Voir la chronologie',
      title: 'Chronologie d\'extraction',
    },
    loading: 'Chargement de l\'extraction...',
    providers: {
      organisation: 'organisation',
      practitioner: 'praticien',
      searchPlaceholder: 'Rechercher {{type}} existant(e)',
      notInList: 'Ce n\'est pas dans la liste',
    },
    sections: {
      measurements: {
        title: 'Mesures extraites',
        columns: {
          measurementName: 'Mesure extraite',
          valueExtracted: 'Valeur extraite',
          unitExtracted: 'Unité (extraite)',
          ucumCode: 'Code UCUM',
          ucumName: 'Nom UCUM',
          loincCode: 'Code LOINC',
          loincName: 'Nom LOINC',
          referenceRangeMin: 'Ref min',
          referenceRangeMax: 'Ref max',
        },
        actions: {
          resetColumns: 'Réinitialiser la visibilité des colonnes',
          edit: 'Modifier les mesures',
          save: 'Enregistrer les mesures',
          cancel: 'Annuler les modifications des mesures',
          deleteRow: 'Supprimer la ligne',
          deleteRowDisabled: 'Activez le mode édition pour supprimer des lignes',
          addRow: 'Ajouter une ligne',
        },
        aria: {
          resetColumns: 'Réinitialiser la visibilité des colonnes',
          edit: 'Modifier les mesures extraites',
          save: 'Enregistrer les mesures extraites',
          cancel: 'Annuler les modifications des mesures extraites',
          deleteRow: 'Supprimer la ligne {{id}}',
        },
        toasts: {
          addSuccess: 'Ligne de mesure ajoutée',
          addError: 'Impossible d\'ajouter la ligne de mesure',
          deleteSuccess: 'Mesure supprimée',
          deleteError: 'Impossible de supprimer la mesure',
        },
      },
      organisation: {
        title: 'Organisation exécutante',
        status: {
          matchFound: 'Organisation trouvée',
          noMatch: 'Aucune correspondance d\'organisation',
        },
        tooltips: {
          validation: 'Veuillez renseigner les bonnes valeurs',
          save: 'Enregistrer les détails de l\'organisation',
          cancel: 'Annuler les modifications de l\'organisation',
        },
        aria: {
          edit: 'Modifier l\'organisation exécutante',
          save: 'Enregistrer les modifications de l\'organisation exécutante',
          cancel: 'Annuler les modifications de l\'organisation extraite',
        },
        fields: {
          name: 'Nom',
          address: 'Adresse',
          houseNumber: 'Numéro',
          city: 'Ville',
          postalCode: 'Code postal',
          countryCode: 'Code pays',
          contactPerson: 'Personne de contact',
          phoneNumber: 'Téléphone',
          emailAddress: 'Adresse e-mail',
        },
      },
      practitioner: {
        title: 'Praticien demandeur',
        status: {
          matchFound: 'Praticien trouvé',
          noMatch: 'Aucune correspondance de praticien',
        },
        tooltips: {
          validation: 'Veuillez renseigner les bonnes valeurs',
          save: 'Enregistrer les détails du praticien',
          cancel: 'Annuler les modifications du praticien',
        },
        aria: {
          edit: 'Modifier le praticien demandeur',
          save: 'Enregistrer les modifications du praticien demandeur',
          cancel: 'Annuler les modifications du praticien extrait',
        },
        fields: {
          name: 'Nom',
          role: 'Rôle',
          phoneNumber: 'Téléphone',
          emailAddress: 'Adresse e-mail',
        },
      },
    },
    sectionSaved: 'Vos modifications sont enregistrées.',
    sectionSaveFailed: 'Vos modifications n\'ont pas pu être enregistrées.',
  },
  masterData: {
    tabs: {
      measurements: 'Mesures',
      units: 'Unités',
    },
    measurementList: {
      subtitle: 'Tous les codes que la plateforme connaît : la version de LOINC et les siens. Ouvre-en un pour voir ses axes et ses unités.',
    },
    measurementCodes: {
      list: {
        columns: {
          name: 'Nom',
          code: 'Code',
          codeSystem: 'Système de codes',
          status: 'Statut',
          inUse: 'Utilisé',
        },
        yes: 'Oui',
        no: 'Non',
        views: {
          label: 'Afficher',
          all: 'Tous les codes',
          inUse: 'Utilisés',
        },
        systemFilter: 'Système de codes',
        systemAll: 'Tous les systèmes de codes',
      },
      general: {
        code: 'Code',
        codeSystem: 'Système de codes',
        name: 'Nom',
        status: 'Statut',
        release: 'Version',
        releaseValue: '{{version}}, chargée le {{date}}',
        releaseNone: 'Sans objet : aucun code de la plateforme n\'a de version.',
        releaseUnknown: 'Non enregistrée pour ce code.',
        valueKind: 'Type de valeur',
        quantityKind: 'Type de grandeur',
      },
      axes: {
        title: 'Ce qui est mesuré',
        component: 'Composant',
        analyte: 'Analyte',
        property: 'Propriété',
        time: 'Temps',
        system: 'Système',
        scale: 'Échelle',
        method: 'Méthode',
        noMethod: 'Aucune',
        unknown: 'La plateforme ne connaît pas les axes de ce code. Il n\'est regroupé avec rien.',
      },
      groups: {
        title: 'Regroupé avec',
        nothing: 'À ce niveau, regroupé avec rien.',
      },
      levels: {
        THIS_CODE: 'Ce code uniquement',
        ANY_METHOD: 'La même chose, quelle que soit la méthode',
      },
      trace: {
        title: 'Retracer une valeur',
        help: 'Saisis le numéro qu\'on te donne pour une valeur. Tu vois sous quelle forme elle a été enregistrée et d\'où elle vient.',
        number: 'Numéro de la valeur',
        show: 'Afficher l\'origine',
      },
      dialog: {
        addTitle: 'Ajouter une mesure de la plateforme',
        editTitle: 'Modifier {{name}}',
        name: 'Nom',
        code: 'Code',
        codeHelp: 'Commence par X, comme X-HAPPY-1. Deux mesures ne partagent jamais le même code.',
        codeSystem: 'Système de codes',
        analyteHelp: 'Laisse vide pour utiliser le composant.',
        noPart: 'Aucun Part ne correspond. Saisis un nom pour en ajouter un.',
        partsFailed: 'Les Parts n\'ont pas pu être lus. Saisis à nouveau pour réessayer.',
        addPart: 'Ajouter « {{name}} » comme nouveau Part',
        partAdded: '{{name}} ajouté comme Part',
        newPropertyKind: 'Type de grandeur pour une nouvelle propriété',
        newPropertyKindHelp: 'Utilisé uniquement si tu ajoutes une nouvelle propriété ci-dessus.',
        noKind: 'Aucun',
      },
    },
    dimensionWords: {
      length: 'longueur',
      mass: 'masse',
      time: 'temps',
      amountOfSubstance: 'quantité de matière',
      electricCurrent: 'courant électrique',
      temperature: 'température',
      luminousIntensity: 'intensité lumineuse',
      dimensionless: 'sans dimension',
      per: 'par',
    },
    unitTabs: {
      label: 'Unités et masses molaires',
      units: 'Liste des unités',
      molarMasses: 'Masses molaires',
    },
    unitList: {
      subtitle: 'Les unités dans lesquelles les valeurs peuvent être enregistrées, pour chaque organisation, avec leur dimension. Les mesures qui en utilisent une se définissent sur chaque mesure.',
      noUcum: 'Pas de code UCUM',
      noDimension: 'Pas de dimension',
      columns: {
        quantityKinds: 'Grandeurs',
      },
    },
    unitDialog: {
      dimensionHelp: 'Pour une unité sans code UCUM, saisis sa dimension ici. Les unités de même dimension peuvent se convertir entre elles.',
      noDimension: 'Pas de dimension',
      ucumHelp: 'Un code de la version UCUM que détient la plateforme, comme kg. Deux unités ne partagent jamais le même code.',
      noUcum: 'Cette unité n\'a pas de code UCUM. Ajoutes-en un si elle en a un, comme kg.',
      workedOut: 'Déduit du code UCUM.',
      workedOutAfterSave: 'Déduit à l\'enregistrement.',
      quantityKinds: 'Grandeurs qu\'elle peut exprimer',
      quantityKindsHelp: 'Une unité convient à une mesure si elle peut exprimer la grandeur que la mesure nomme. Reprise de QUDT ou choisie ici.',
      dimensionsFailed: 'Les dimensions n\'ont pas pu être lues, aucune ne peut donc être choisie.',
      dimensionsRetry: 'Réessayer',
    },
    measurementUnits: {
      add: 'Lier une unité',
      edit: 'Modifier le lien',
      remove: 'Retirer le lien',
      isDefault: 'Canonique',
      columns: {
        isDefault: 'Canonique',
        conversion: 'Conversion vers l\'unité canonique',
        approvedBy: 'Approuvé par',
        validMinimum: 'Valide à partir de',
        validMaximum: 'Valide jusqu\'à',
      },
      confirm: 'Confirmer le facteur',
      confirmedToast: 'Facteur de {{unit}} confirmé',
      factor: '1 {{from}} = {{multiplier}} {{to}}',
      factorWithOffset: '({{from}} + {{offset}}) × {{multiplier}} = {{to}}',
      viaAlgebra: 'Déduit des codes UCUM.',
      viaMolarMass: 'Via la masse molaire de {{analyte}}, {{mass}} g/mol. Source : {{source}}.',
      formula: '{{factor}}. {{via}}',
      approved: '{{by}}, {{date}}',
      notApproved: 'Pas encore approuvé',
      unavailable: {
        dimensionDiffers: 'Pas de facteur : cette unité a une autre dimension que l\'unité canonique.',
        noCanonicalUnit: 'Pas encore de facteur : la mesure n\'a pas d\'unité canonique.',
        noMolarMass: 'Pas encore de facteur : la masse molaire de l\'analyte n\'est pas enregistrée.',
        noDimension: 'Pas de facteur : cette unité n\'a pas de dimension.',
      },
      enterMolarMass: 'Saisir la masse molaire',
      removeDialog: {
        title: 'Retirer ce lien ?',
      },
    },
    unitLinkDialog: {
      isDefault: 'Unité canonique : les valeurs s\'affichent dans cette unité et sa plage est vérifiée',
      isDefaultHelp: 'La première unité d\'une mesure est son unité canonique. Il n\'y en a qu\'une.',
      otherDefault: 'Une autre unité est la canonique. Désactive-la d\'abord là-bas.',
      validMinimum: 'Minimum valide',
      validMaximum: 'Maximum valide',
      validHelp: 'Facultatif. La valeur la plus basse qui peut être enregistrée, en {{unit}}. Une valeur dans une autre unité est d\'abord convertie.',
      rangeWrong: 'Le minimum est supérieur au maximum.',
    },
    molarMasses: {
      title: 'Masses molaires',
      subtitle: 'Une concentration massique rejoint une concentration molaire du même analyte par sa masse molaire. Chaque masse a sa source.',
      add: 'Ajouter une masse molaire',
      edit: 'Modifier la masse molaire',
      remove: 'Retirer la masse molaire',
      addTitle: 'Ajouter une masse molaire',
      editTitle: 'Modifier la masse molaire de {{name}}',
      columns: {
        analyte: 'Analyte',
        gramsPerMole: 'Grammes par mole',
        source: 'Source',
      },
      analyte: 'Analyte',
      analyteHelp: 'Cherche par nom ou numéro de Part, comme Glucose.',
      gramsPerMole: 'Grammes par mole',
      massHelp: 'Pour le glucose : 180.156.',
      massWrong: 'Saisis un nombre supérieur à 0, avec jusqu\'à dix chiffres avant et après la virgule.',
      source: 'Source',
      sourceHelp: 'D\'où vient le nombre : un groupe LOINC, un identifiant ChEBI ou PubChem, un ouvrage de référence.',
      removeDialog: {
        title: 'Retirer cette masse molaire ?',
        message: '{{name}} n\'a plus de masse molaire. Les facteurs qui l\'utilisent ne peuvent plus être calculés.',
      },
    },
  },
  tenantSettings: {
    title: 'Paramètres du Tenant',
    subtitle: 'Gérer les paramètres',
    loadError: 'Échec du chargement des paramètres du tenant. Vous n\'avez peut-être pas la permission de voir ce tenant.',
    generalInfo: 'Informations Générales',
    tenantName: 'Nom du Tenant',
    organisation: 'Organisation',
    organisationHelper: 'L\'organisation ne peut pas être modifiée',
    tenantId: 'ID du Tenant',
    yourRole: 'Votre Rôle',
    roleDescription: 'Votre rôle dans cette organisation est {{role}}.',
    permissionsConfigured: 'Ce que ce rôle peut faire est configuré par l\'organisation. Un administrateur peut le voir et le modifier sur l\'écran des rôles.',
    saveName: 'Enregistrer le nom',
    nameSaved: 'Le nom du locataire a été mis à jour.',
    saveError: 'Le nom n\'a pas pu être enregistré. Vous n\'avez peut-être pas l\'autorisation de le modifier.',
  },
  communityUsers: {
    title: 'Utilisateurs de la communauté',
    subtitle: 'Tous les utilisateurs ayant un compte sur la plateforme. Les détails personnels ne sont affichés qu\'en fonction des préférences de confidentialité de chaque utilisateur.',
    loadError: 'Échec du chargement des utilisateurs de la communauté. Veuillez réessayer.',
    view: 'Voir',
    noUsersTitle: 'Aucun utilisateur partagé',
    noUsersNotice: 'Personne n\'a encore rendu ses données disponibles à la consultation.',
  },
  adminDashboard: {
    menuItems: {
      questionnaires: 'Questionnaires',
      tenants: 'Locataires',
      organisations: 'Organisations',
      users: 'Utilisateurs du système',
    },
    users: {
      title: 'Utilisateurs du système',
      comingSoon: 'La gestion des utilisateurs arrive bientôt...',
    },
  },
  organisationDialog: {
    titleCreate: 'Créer une Nouvelle Organisation',
    titleEdit: 'Modifier l’organisation',
    emailInvalid: 'Saisissez une adresse e-mail comme nom@exemple.fr',
    dateInvalid: 'Saisissez une date',
    legalNameRequired: 'Le nom légal est requis',
    createError: 'Échec de la création de l\'organisation. Veuillez vérifier si les champs uniques sont déjà utilisés.',
    fields: {
      legalName: 'Nom Légal',
      tradeName: 'Nom Commercial',
      taxId: 'Numéro Fiscal',
      referenceCode: 'Code de Référence',
      emailAddress: 'Adresse E-mail',
      phoneNumber: 'Numéro de Téléphone',
      website: 'Site Web',
      practiceCode: 'Code de Pratique',
      chamberOfCommerceNumber: 'Numéro de Chambre de Commerce',
      subscriptionDate: 'Date d\'Abonnement',
      active: 'Actif',
    },
    actions: {
      create: 'Créer',
    },
  },
  organisationList: {
    title: 'Organisations',
    addButton: 'Ajouter une organisation',
    updateSuccess: 'Organisation mise à jour avec succès',
    updateError: 'Échec de la mise à jour de l\'organisation',
    columns: {
      legalName: 'Raison sociale',
      tradeName: 'Nom commercial',
      taxId: 'Numéro fiscal',
      referenceCode: 'Code de référence',
      emailAddress: 'Email',
      phoneNumber: 'Téléphone',
      website: 'Site web',
      practiceCode: 'Code de pratique',
      chamberOfCommerceNumber: 'Numéro de chambre de commerce',
      subscriptionDate: 'Date d\'abonnement',
      status: 'Statut',
    },
    statusLabels: {
      active: 'Actif',
      inactive: 'Inactif',
    },
    edit: 'Modifier',
    deactivate: 'Désactiver',
    alreadyInactive: 'Déjà inactive. Réactivez-la avec Modifier.',
    deactivateTitle: 'Désactiver l’organisation',
    deactivateMessage: '{{name}} sera marquée comme inactive. Rien n’est supprimé, et vous pouvez la réactiver avec Modifier.',
    deactivated: 'Organisation désactivée',
    created: 'Organisation créée',
  },
  questionnaireEditor: {
    questionsCount: 'Questions ({{count}})',
    addQuestionButton: 'Ajouter une question',
    emptyState: {
      message: 'Aucune question pour l\'instant. Ajoutez votre première question !',
      button: 'Ajouter une question',
    },
    question: {
      prefix: 'Question',
      required: 'Obligatoire',
      identity: 'Identité : ',
      optionsLabel: 'Options :',
    },
    tooltips: {
      edit: 'Modifier',
      delete: 'Supprimer',
    },
    dialog: {
      titleNew: 'Nouvelle question',
      titleEdit: 'Modifier la question',
      questionType: 'Type de question',
      questionPrompt: 'Libellé de la question',
      requiredQuestion: 'Question obligatoire',
      identityField: 'Ceci est un champ d\'identité (pour l\'intégration des utilisateurs)',
      identityFieldType: 'Type de champ d\'identité',
      listOptionsTitle: 'Options de liste',
      addOptionButton: 'Ajouter une option',
      codeLabel: 'Code',
      codePlaceholder: 'ex., SAT_HAUT',
      valueLabel: 'Valeur d\'affichage',
      valuePlaceholder: 'ex., Très satisfait',
      emptyOptions: 'Ajoutez au moins une option pour les questions déroulantes',
      cancel: 'Annuler',
      save: 'Enregistrer',
      create: 'Créer',
      removeOption: 'Retirer l’option',
    },
    deleteDialog: {
      title: 'Supprimer la question',
      message: 'Êtes-vous sûr de vouloir supprimer cette question ? Cela supprimera également toutes les réponses associées.',
      cancel: 'Annuler',
      delete: 'Supprimer',
    },
    messages: {
      updateSuccess: 'Question mise à jour avec succès',
      createSuccess: 'Question créée avec succès',
      deleteSuccess: 'Question supprimée avec succès',
      saveError: 'Échec de l\'enregistrement de la question',
      deleteError: 'Échec de la suppression de la question',
    },
    questionTypes: {
      text: 'Texte',
      number: 'Nombre',
      date: 'Date',
      list: 'Liste/Menu déroulant',
      boolean: 'Oui/Non',
    },
    identityTypes: {
      first_name: 'Prénom',
      last_name: 'Nom de famille',
      email: 'Email',
      date_of_birth: 'Date de naissance',
    },
  },
  questionnaireList: {
    title: 'Questionnaires',
    newButton: 'Ajouter un questionnaire',
    table: {
      name: 'Nom',
      description: 'Description',
      status: 'Statut',
      version: 'Version',
      publicLink: 'Lien public',
    },
    statusLabels: {
      active: 'Actif',
      inactive: 'Inactif',
    },
    dialog: {
      titleNew: 'Ajouter un questionnaire',
      titleEdit: 'Modifier le questionnaire',
      name: 'Nom',
      description: 'Description',
      active: 'Actif',
      create: 'Créer',
      nameRequired: 'Saisissez un nom',
      publicLink: 'Lien public',
      noPublicLink: 'Ce questionnaire n’a pas encore de lien public.',
      newLink: 'Créer un nouveau lien à l’enregistrement. Le lien actuel ne fonctionnera plus.',
      makeLink: 'Créer un lien public à l’enregistrement',
    },
    deleteDialog: {
      title: 'Supprimer le questionnaire',
      message: '{{name}} et ses questions seront supprimés. Un questionnaire auquel des personnes ont répondu n’est pas supprimé ; désactivez-le plutôt.',
      delete: 'Supprimer',
    },
    messages: {
      updateSuccess: 'Questionnaire mis à jour avec succès',
      createSuccess: 'Questionnaire créé avec succès',
      deleteSuccess: 'Questionnaire supprimé',
      saveError: 'Échec de l\'enregistrement du questionnaire',
      linkCopied: 'Lien copié dans le presse-papiers',
      copyFailed: 'Le lien n’a pas pu être copié',
    },
    copyLink: 'Copier le lien',
    copyLinkOf: 'Copier le lien public de {{name}}',
    noLink: 'Aucun',
    edit: 'Modifier',
    delete: 'Supprimer',
    noOrganisationTitle: 'Pas encore d’organisation',
    noOrganisationNotice: 'Les questionnaires appartiennent à une organisation, et ce compte n’appartient à aucune.',
  },
  submissionViewer: {
    table: {
      id: 'ID',
      status: 'Statut',
      email: 'Email',
      name: 'Nom',
      submittedAt: 'Soumis le',
    },
    statusLabels: {
      submitted: 'Soumis',
      draft: 'Brouillon',
      scored: 'Noté',
      abandoned: 'Abandonné',
    },
    dialog: {
      title: 'Soumission - Réponses',
      submissionDetails: 'Détails de la soumission',
      status: 'Statut',
      submittedAt: 'Soumis le',
      notYetSubmitted: 'Pas encore soumis',
      email: 'Email',
      name: 'Nom',
      answersCount: 'Réponses ({{count}})',
      noAnswers: 'Aucune réponse soumise.',
      questionPrefix: 'Question {{number}}',
      close: 'Fermer',
      unknownQuestion: 'Une question qui ne figure plus dans ce questionnaire',
    },
    booleanValues: {
      yes: 'Oui',
      no: 'Non',
    },
    answersFailed: 'Les réponses n’ont pas pu être chargées',
    openAnswers: 'Réponses envoyées le {{sent}}',
  },
  tenantList: {
    title: 'Locataires',
    addButton: 'Ajouter un Locataire',
    saveError: 'Échec de l\'enregistrement du locataire',
    noOrganisationsWarning: 'Aucune organisation disponible. Créez d\'abord une organisation avant d\'ajouter des locataires.',
    table: {
      id: 'ID',
      name: 'Nom',
      organisation: 'Organisation',
    },
    tooltips: {
      edit: 'Modifier',
    },
    dialog: {
      titleCreate: 'Créer un Locataire',
      titleEdit: 'Modifier le Locataire',
      tenantName: 'Nom du Locataire',
      organisation: 'Organisation',
      create: 'Créer',
      nameRequired: 'Saisissez un nom',
      organisationRequired: 'Choisissez une organisation',
      organisationLocked: 'Un locataire reste dans son organisation',
    },
    messages: {
      created: 'Locataire ajouté',
      updated: 'Locataire enregistré',
    },
  },
  publicQuestionnairePage: {
    loading: 'Chargement...',
    invalidLink: 'Lien de questionnaire invalide',
    notFound: 'Questionnaire introuvable ou plus actif',
    checkLink: 'Veuillez vérifier le lien et réessayer.',
    thankYou: 'Merci!',
    submitted: 'Vos réponses ont été soumises avec succès.',
    newAccountCreated: 'Un nouveau compte a été créé pour vous. Consultez votre e-mail pour les instructions de connexion.',
    progress: 'Progression',
    questions: 'questions',
    required: 'Ce champ est obligatoire',
    identityFieldInfo: 'Ces informations seront utilisées pour créer votre compte',
    submitButton: 'Soumettre le Questionnaire',
    submitting: 'Envoi en cours...',
    autoSave: 'Vos réponses sont enregistrées automatiquement pendant que vous tapez',
    missingRequired: 'Veuillez répondre à toutes les questions obligatoires ({{count}} restantes)',
    submitError: 'Échec de la soumission du questionnaire. Veuillez réessayer.',
    placeholders: {
      text: 'Entrez votre réponse...',
      number: 'Entrez un nombre...',
      email: 'Entrez votre e-mail',
      firstName: 'Entrez votre prénom',
      lastName: 'Entrez votre nom de famille',
      dateOfBirth: 'Entrez votre date de naissance',
    },
    booleanValues: {
      yes: 'Oui',
      no: 'Non',
    },
    answerSaveFailed: 'Votre réponse n\'a pas pu être enregistrée. Veuillez réessayer.',
  },
  manageProgrammeMeasurements: {
    title: 'Mesures de Programme',
    tenant: 'Locataire',
    addButton: 'Ajouter une Mesure de Programme',
    noProgrammes: 'Aucun programme disponible. Veuillez créer un programme en premier.',
    noOrganisationTitle:
      'Pas encore d’organisation',
    noOrganisation: 'Les mesures de programme appartiennent à une organisation, et ce compte n’appartient à aucune.',
    rolesUnknownTitle: 'Vos rôles sont illisibles',
    rolesUnknownNotice:
      'Sans eux, cet écran ne sait pas quelle organisation afficher, ce qui n’est pas la même chose que n’appartenir à aucune.',
    table: {
      programmeName: 'Nom du Programme',
      measurementName: 'Nom de la Mesure',
      loincCode: 'Code LOINC',
      minimumTarget: 'Objectif Minimum',
      maximumTarget: 'Objectif Maximum',
      defaultUnit: 'Unité par Défaut',
      reminder: 'Rappel',
      everyWeeks: 'Toutes les {{count}} semaines : {{days}}',
    },
    actions: {
      edit: 'Modifier',
      delete: 'Supprimer',
    },
    dialog: {
      titleAdd: 'Ajouter une Mesure de Programme',
      titleEdit: 'Modifier une Mesure de Programme',
      programme: 'Programme',
      measurement: 'Mesure',
      minimumTarget: 'Objectif Minimum',
      maximumTarget: 'Objectif Maximum',
      defaultUnit: 'Unité par Défaut',
      selectProgramme: 'Sélectionner un programme',
      selectMeasurement: 'Sélectionner une mesure',
      measurementSearchHint: 'Saisis au moins trois lettres du nom ou du code.',
      measurementNoMatch: 'Aucune mesure ne correspond.',
      measurementSearchFailed: 'Les mesures n\'ont pas pu être lues. Saisis à nouveau pour réessayer.',
      selectUnit: 'Sélectionner une unité',
      repeatEvery: 'Répéter tous les',
      weeks: 'semaines',
      repeatOn: 'Répéter le',
      ends: 'Se termine',
      endsProgrammeEnd: 'À la fin du programme',
      endsOn: 'Le',
      endsAfter: 'Après',
      occurrences: 'occurrences',
      timeOfDay: 'À',
      timeOfDayOptional: 'facultatif',
      selectWeekdaysFirstWarning: 'Sélectionnez d’abord un jour de la semaine',
      recurrenceHint: 'Ne sélectionnez aucun jour pour n\'enregistrer aucune planification. Les semaines sont comptées à partir de la semaine de début du programme.',
      programmeHasNoEndDate: 'Ce programme n\'a pas de date de fin ; il se répète donc indéfiniment',
      save: 'Enregistrer',
      update: 'Mettre à jour',
    },
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer la mesure "{{measurementName}}" du programme "{{programmeName}}" ?',
    deleteTitle: 'Retirer cette mesure du programme ?',
    messages: {
      loadRolesFailed: 'Échec du chargement des rôles de locataire',
      loadDataFailed: 'Échec du chargement des données',
      partlyRead: 'Les mesures de certains programmes n’ont pas pu être lues : cette liste est peut-être incomplète.',
      noTenantSelected: 'Aucun locataire sélectionné',
      selectProgrammeError: 'Veuillez sélectionner un programme',
      selectMeasurementError: 'Veuillez sélectionner une mesure',
      selectUnitError: 'Veuillez sélectionner une unité par défaut',
      recurrenceIntervalError: 'Répéter tous les doit être un nombre entier de semaines entre 1 et 52',
      recurrenceEndDateError: 'Choisissez une date de fin qui n\'est pas antérieure au début du programme',
      recurrenceOccurrencesError: 'Le nombre d\'occurrences doit être un nombre entier entre 1 et 520',
      deleteSuccess: 'Mesure de programme supprimée avec succès',
      addSuccess: 'Mesure de programme ajoutée avec succès',
      addFailed: 'Échec de l\'ajout de la mesure de programme',
      updateSuccess: 'Mesure de programme mise à jour avec succès',
      updateFailed: 'Échec de la mise à jour de la mesure de programme',
      notAllowed: 'Tu ne peux pas modifier cela.',
    },
  },
  manageProgrammeDialog: {
    titleCreate: 'Créer un Nouveau Programme',
    titleEdit: 'Modifier le Programme',
    programmeName: 'Nom du Programme',
    programmeNameRequired: 'Le nom du programme est obligatoire',
    description: 'Description',
    targetAudience: 'Public Cible',
    startDate: 'Date de Début',
    startDateRequired: 'La date de début est obligatoire',
    startDateLocked:
      'La date de début ne peut plus être modifiée après la création',
    endDate: 'Date de Fin',
    endDateHelper: 'Laisser vide pour les programmes en cours',
    endDateError: 'La date de fin doit être postérieure à la date de début',
    startDatePast: 'La date de début ne peut pas être dans le passé',
    endDatePast: 'La date de fin ne peut pas être dans le passé',
    saveChanges: 'Enregistrer les Modifications',
    createProgramme: 'Créer le Programme',
    saveFailed: 'Échec de l\'enregistrement du programme',
    banner: {
      label: 'Bannière',
      choose: 'Choisir une image',
      remove: 'Retirer la bannière',
      none: 'Pas encore de bannière. Les membres voient le nom du programme sur la couleur du tenant.',
      accepted: 'PNG, WebP ou JPEG, 2 Mo au plus, entre 800 × 200 et 6000 × 6000 pixels.',
      refused: 'Ce fichier ne peut pas être utilisé. Choisissez une image PNG, WebP ou JPEG de 2 Mo au plus, entre 800 × 200 et 6000 × 6000 pixels.',
      saveFailed: 'La bannière n’a pas pu être enregistrée. Réessayez.',
    },
  },
  manageProgrammes: {
    title: 'Programmes',
    addButton: 'Ajouter un Programme',
    tenant: 'Locataire',
    loadRolesFailed: 'Échec du chargement des rôles de locataire',
    loadProgrammesFailed: 'Échec du chargement des programmes',
    table: {
      programmeName: 'Nom du programme',
      description: 'Description',
      target: 'Cible',
      startDate: 'Date de début',
      endDate: 'Date de fin',
    },
    actions: {
      edit: 'Modifier',
      delete: 'Supprimer',
    },
    deleteDialog: {
      title: 'Supprimer le Programme',
      message: 'Êtes-vous sûr de vouloir supprimer le programme "{{programmeName}}" ? Cette action ne peut pas être annulée.',
      delete: 'Supprimer',
    },
    messages: {
      createSuccess: 'Programme créé avec succès',
      updateSuccess: 'Programme mis à jour avec succès',
      deleteSuccess: 'Programme supprimé avec succès',
    },
    ongoing: 'En cours',
    loadFailedTitle: 'Programmes illisibles',
    noOrganisationNotice: 'Les programmes appartiennent à une organisation, et ce compte n’appartient à aucune.',
    noOrganisationTitle: 'Pas encore d’organisation',
    rolesUnknownNotice: 'Sans eux, cet écran ne sait pas ce que vous administrez, ce qui n’est pas la même chose que rien administrer.',
    rolesUnknownTitle: 'Vos rôles sont illisibles',
  },
  programmesOverview: {
    title: 'Programmes Disponibles',
    loadFailed: 'Échec du chargement des programmes',
    enrollFailed: 'Échec de l\'inscription au programme',
    enroll: 'S\'inscrire',
    unenroll: 'Se désinscrire',
    unenrollFailed: 'Échec de la désinscription du programme',
    preview: 'Aperçu',
    table: {
      programmeName: 'Nom du Programme',
      target: 'Cible',
      programmeStartDate: 'Date de Début du Programme',
      programmeEndDate: 'Date de Fin du Programme',
      enrollmentStatus: 'Statut d\'Inscription',
    },
    status: {
      notEnrolled: 'Non Inscrit',
      active: 'Actif',
      inactive: 'Inactif',
    },
    previewPanel: {
      enrolledFrom: 'Vous êtes inscrit à ce programme depuis :',
      ongoing: 'Aujourd\'hui',
    },
    noProgrammesNotice: 'Votre organisation n’a encore ouvert aucun programme aux inscriptions.',
    noProgrammesTitle: 'Aucun programme pour l’instant',
    programmesUnknownNotice: 'La liste n’est pas arrivée, ce qui n’est pas la même chose qu’aucun programme.',
    programmesUnknownTitle: 'Programmes illisibles',
    retry: 'Réessayer',
    close: 'Fermer',
    confirmUnenroll: {
      title: 'Quitter ce programme ?',
      body: 'Vous serez désinscrit de {{programme}}. Vous pourrez vous réinscrire plus tard.',
      cancel: 'Annuler',
      confirm: 'Se désinscrire',
    },
  },
  observations: {
    addObservation: 'Ajouter une mesure',
    viewToggleLabel: 'Vue',
    viewCalendar: 'Calendrier',
    viewStack: 'Pile',
    viewTimeline: 'Chronologie',
    filter: {
      title: 'Filtrer',
      label: 'Programmes',
      all: 'Tous les programmes',
    },
    submitting: 'Envoi en cours...',
    searchBy: 'Rechercher par',
    searchValue: 'Valeur de recherche',
    sourceDocument: 'Source du document',
    sourceDocumentDescription: 'Description du document',
    columns: 'Colonnes',
    columnsLabel: 'Modifier Colonnes Affichées',
    eventType: 'Type d\'événement',
    dateTime: 'Date et heure',
    measurementType: 'Type de mesure',
    value: 'Valeur',
    actions: 'Actions',
    eventTypes: {
      manualInput: 'Saisie Manuelle',
      deviceSync: 'Synchronisation Appareil',
      uploaded: 'Téléchargé',
      coachingSession: 'Session de Coaching',
    },
    validation: {
      eventTypeRequired: 'Le type d\'événement est requis',
      dateTimeRequired: 'La date et l\'heure sont requises',
      invalidDateTime: 'Date et heure invalides',
      atLeastOneMeasurement: 'Saisissez au moins une valeur de mesure',
      invalidValue: 'Valeur invalide',
      validationFailed: 'Échec de la validation',
      fixErrors: 'Veuillez corriger toutes les erreurs de validation avant de soumettre',
    },
    messages: {
      noChanges: 'Aucune modification à enregistrer',
      successSingle: 'Observation enregistrée avec succès',
      successMultiple: 'Toutes les entrées d\'observation soumises avec succès !',
      submitError: 'Erreur lors de l\'envoi des observations',
      updateError: 'Erreur lors de la mise à jour de l\'observation',
      deleteSuccess: 'Observation supprimée avec succès',
      removeSuccess: 'Observation supprimée',
      deleteError: 'Erreur lors de la suppression de l\'observation',
      loadError: 'Erreur lors du chargement des observations',
      networkError: 'Erreur réseau',
      saveError: 'Erreur lors de l\'enregistrement des modifications',
    },
    dialog: {
      deleteTitle: 'Supprimer Observation',
      deleteMessage: 'Êtes-vous sûr de vouloir supprimer cet événement d\'observation ? Cette action ne peut pas être annulée.',
      cancel: 'Annuler',
      delete: 'Supprimer',
    },
    dayView: {
      previousDay: 'Jour précédent',
      nextDay: 'Jour suivant',
      today: 'Aujourd\'hui',
      noEntries: 'Aucune observation enregistrée ce jour-là',
      edit: 'Modifier',
      save: 'Enregistrer',
      dataTypeNumber: 'Nombre',
      dataTypeText: 'Texte',
      dataTypeBoolean: 'Oui/non',
      noProgramme: 'Aucun programme',
      noValues: 'Aucune valeur enregistrée',
      newMeasurementTitle: 'Nouvelle Mesure',
      previewPending: 'Pas encore enregistré',
      programme: 'Programme',
      selectProgramme: 'Sélectionner un programme',
      measurement: 'Mesure',
      selectMeasurement: 'Sélectionnez une mesure',
      noMeasurementSelected: 'Sélectionnez une mesure avant de saisir une valeur',
      noProgrammeSelected: 'Sélectionnez un programme avant de sélectionner une mesure',
      value: 'Valeur',
      viewLabel: 'Affichage',
      viewDay: 'Jour',
      viewWeek: 'Semaine',
      viewMonth: 'Mois',
      previousWeek: 'Semaine précédente',
      nextWeek: 'Semaine suivante',
      previousMonth: 'Mois précédent',
      nextMonth: 'Mois suivant',
      noEntriesRange: 'Aucune observation enregistrée sur cette période',
      legendTitle: 'Programmes',
      legendScheduledLabel: 'Mesure planifiée',
      legendNotInProgramme: 'Hors programme',
      dueLabel: 'À relever',
      doneLabel: 'Fait',
      dueTooltip: '{{measurement}} — {{programme}}',
      recordDue: 'Relever {{measurement}}',
      slotHint: 'Cliquez sur une plage libre de l\'agenda pour relever quelque chose de nouveau',
      moreEvents: '+{{count}} de plus',
    },
  },
  settings: {
    title: 'Paramètres de langue et de région',
    language: 'Langue',
    region: 'Région',
    systemOfMeasurement: 'Système de Mesure',
    timezone: 'Fuseau Horaire',
    metricSystem: 'Système Métrique',
    imperialSystem: 'Système Impérial',
    usCustomaryUnits: 'Unités Usuelles Américaines',
    regionInfoTitle: 'Informations Régionales',
    regionInfoText: 'Choisissez votre région pour afficher les nombres, dates et heures dans les formats locaux.',
    regionInfo: 'Choisissez votre région pour afficher les nombres, dates et heures dans les formats locaux.',
    selectLanguage: 'Sélectionner la Langue',
    selectRegion: 'Sélectionner la Région',
    selectMeasurement: 'Sélectionner le Système de Mesure',
    selectTimezone: 'Sélectionner le Fuseau Horaire',
    preview: 'Aperçu',
    formatExamples: 'Exemples de Format',
    save: 'Enregistrer',
    cancel: 'Annuler',
    saving: 'Enregistrement...',
    savedSuccessfully: 'Paramètres enregistrés avec succès!',
    saveSuccess: 'Paramètres enregistrés avec succès!',
    warningTitle: 'Confirmer les Modifications',
    warningMessage: 'Ces modifications prendront effet immédiatement. Les changements de langue mettront à jour l\'interface immédiatement, tandis que les paramètres régionaux et de mesure s\'appliqueront à toutes les données affichées.',
    confirmSave: 'Enregistrer les Modifications',
    languageLabel: 'Langue',
    regionLabel: 'Région',
    measurementLabel: 'Mesure',
    numberLabel: 'Nombre',
    dateLabel: 'Date',
    timeLabel: 'Heure',
    weightLabel: 'Poids',
    heightLabel: 'Taille',
    distanceLabel: 'Distance',
    temperatureLabel: 'Température',
    saveFailed: 'Vos paramètres n\'ont pas pu être enregistrés.',
    languageSaveFailed: 'Votre choix de langue n\'a pas pu être enregistré.',
  },
  actions: {
    add: 'Ajouter',
    view: 'Voir',
    edit: 'Modifier',
    delete: 'Supprimer',
    save: 'Enregistrer',
    cancel: 'Annuler',
    close: 'Fermer',
    open: 'Ouvrir',
  },
  recordPage: {
    path: 'Chemin',
    general: 'Général',
  },
  programmePage: {
    measurements: 'Mesures',
    dashboards: 'Tableau de bord',
    notFoundTitle: 'Ce programme est introuvable',
    notFoundBody: 'Il a peut-être été supprimé, ou il appartient à une autre organisation.',
    loadFailedTitle: 'Ce programme n’a pas pu être lu',
    loadFailed: 'Réessayez dans un instant.',
  },
  programmeBoards: {
    loading: 'Chargement du tableau de bord',
    panelTitle: 'Le tableau de bord de ce programme',
    panelHint: 'Chaque membre de ce programme le retrouve sur son tableau de bord dès qu’il contient un bloc. Ce que vous enregistrez apparaît aussitôt.',
    name: 'Nom',
    nameHint: 'Laissé vide, il prend le nom du programme.',
    unsaved: 'Non enregistré',
    save: 'Enregistrer',
    discard: 'Annuler les modifications',
    saved: 'Enregistré. Les membres de ce programme le voient maintenant.',
    saveFailed: 'Le tableau de bord n’a pas pu être enregistré. Réessayez.',
    emptyTitle: 'Ce tableau de bord est encore vide',
    emptyBody: 'Choisissez un bloc ci-dessus. Les membres voient le tableau de bord dès qu’il en contient un.',
    deniedTitle: 'Vous ne pouvez pas modifier le tableau de bord de ce programme',
    deniedBody: 'Il faut pour cela le droit de configurer ce programme.',
    loadFailedTitle: 'Le tableau de bord n’a pas pu être lu',
    retry: 'Réessayer',
    galleryHint: 'Choisissez un bloc pour le placer en bas de ce tableau de bord. Chaque bloc montre une mesure de ce programme.',
    arrangeHint: 'Faites glisser un bloc par sa poignée ou tirez son coin inférieur droit. Chaque membre y voit ses propres valeurs.',
    noMeasurements: 'Ce programme ne suit encore aucune mesure. Ajoutez-en une d’abord dans l’onglet Mesures.',
  },
  questionnairePage: {
    questions: 'Questions',
    submissions: 'Soumissions',
    notFoundTitle: 'Ce questionnaire est introuvable',
    notFoundBody: 'Il a peut-être été supprimé, ou il appartient à une autre organisation.',
    loadFailedTitle: 'Ce questionnaire n’a pas pu être lu',
    loadFailed: 'Réessayez dans un instant.',
  },
  tenantPage: {
    administrators: 'Administrateurs',
    notFoundTitle: 'Ce locataire est introuvable',
    notFoundBody: 'Il a peut-être été supprimé, ou l’adresse est erronée.',
    loadFailedTitle: 'Ce locataire n’a pas pu être lu',
    loadFailed: 'Réessayez dans un instant.',
    table: {
      name: 'Nom',
      email: 'Email',
    },
    addButton: 'Ajouter un administrateur',
    remove: 'Retirer',
    removeTitle: 'Retirer l’administrateur',
    removeMessage: '{{name}} n’administrera plus {{tenant}}. Son compte et son lien avec l’organisation sont conservés.',
    removed: 'Administrateur retiré',
    added: 'Administrateur ajouté',
    add: {
      title: 'Ajouter un administrateur à {{tenant}}',
      person: 'Personne',
      personRequired: 'Choisissez une personne',
      nobody: 'Personne dans cette organisation ne peut être choisi.',
      peopleFailed: 'Les personnes de cette organisation n’ont pas pu être lues.',
      save: 'Ajouter',
      failed: 'L’administrateur n’a pas pu être ajouté.',
    },
  },
  grid: {
    noRowsTitle: 'Rien pour l’instant',
    noRowsNotice: 'Les lignes apparaissent dès qu’il y a quelque chose à montrer.',
    noResultsTitle: 'Aucun résultat',
    noResultsNotice: 'Essayez une recherche plus courte, ou effacez les filtres.',
    actions: 'Actions',
    edit: 'Modifier',
    remove: 'Supprimer',
    clearSearch: 'Effacer la recherche',
    cancel: 'Annuler',
    save: 'Enregistrer',
    saving: 'Enregistrement…',
    actionFailed: 'Cela n’a pas fonctionné. Rien n’a été modifié.',
    loadFailedTitle: 'Impossible de lire cette liste',
    add: 'Ajouter',
    filter: 'Filtrer',
    searchAll: 'Rechercher dans toutes les colonnes',
    sortByField: 'Trier par : {{field}}',
    sortByFieldDirection: 'Trier par : {{field}}, {{direction}}',
    filterWithCount: 'Filtrer ({{count}})',
    newestFirst: 'Les plus récents d’abord',
    noResultsFor: 'Aucun résultat pour « {{query}} »',
    clearSearchAndFilters: 'Effacer la recherche et les filtres',
    tryAgain: 'Réessayer',
    rowsPerPage: 'Lignes par page',
    range: '{{from}}–{{to}} sur {{count}}',
    previousPage: 'Page précédente',
    nextPage: 'Page suivante',
  },
  coaches: {
    title: 'Coachs',
    subtitle:
      'Les coachs que propose votre organisation. Vous choisissez qui ' +
      'solliciter, et ce qu\'il peut voir de vos mesures.',
    coachingSubtitle: 'Les personnes que vous accompagnez, les demandes qui vous sont adressées, et la façon dont l\'annuaire vous présente.',
    unnamedCoach: 'Coach sans nom',
    unnamedMember: 'Membre sans nom',

    requestPendingChip: 'Demande envoyée',
    ask: 'Solliciter ce coach',
    details: 'Détails',
    withdrawRequest: 'Retirer la demande',
    access: {
      held: 'Voit {{see}} de vos mesures et peut saisir {{record}}.',
      asked: 'Demande à voir {{see}} mesures et à saisir {{record}}.',
    },
    cannotAsk: {
      alreadyMyCoach: 'Ce coach voit déjà vos mesures.',
      requestPending: 'Votre demande attend encore une réponse.',
      notAccepting: 'Ce coach n\'accueille personne de nouveau pour le moment.',
    },

    askTitle: 'Solliciter {{name}}',
    askExplainer:
      'Choisissez ce que ce coach peut voir. Vous pouvez le modifier, ou y ' +
      'mettre fin, à tout moment dans la rubrique Vos coachs.',
    measurement: 'Mesure',
    maySee: 'Peut voir',
    mayRecord: 'Peut saisir',
    maySeeAria: 'Peut voir {{name}}',
    mayRecordAria: 'Peut saisir {{name}}',
    messageLabel: 'Message (facultatif)',
    sendRequest: 'Envoyer la demande',
    askFailed: 'La demande n\'a pas pu être envoyée.',
    scopesUnavailable: 'Les mesures de votre programme n\'ont pas pu être lues.',
    noProgrammeYet:
      'Vous ne suivez pas encore de programme, et ce qui peut être partagé vient du programme.',
    someUnsharable:
      'Pas encore partageables : {{names}}. Ces mesures n’ont pas de code LOINC — demandez à un administrateur d’en associer un.',
    noMeasurementsYet:
      'Votre programme ne nomme encore aucune mesure : il n\'y a rien à partager.',

    waitingForYou: 'Attend votre réponse',
    stillWaiting: 'Attend encore une réponse',
    earlierRequests: 'Demandes précédentes',
    offeredAccess: 'Ce qui a été demandé',
    sharedProgrammes: 'Programmes que vous partagez',
    askedOn: 'Demandé le {{when}}',
    answerableUntil: 'Peut recevoir une réponse jusqu\'au {{when}}',
    expiredOn: 'Expirée le {{when}}',
    expired: 'Expirée',
    accept: 'Accepter',
    decline: 'Refuser',
    declineTitle: 'Refuser la demande',
    declineReasonLabel: 'Motif (facultatif)',
    actionFailed: 'Cela n\'a pas fonctionné.',
    status: {
      pending: 'En attente de réponse',
      accepted: 'Acceptée',
      declined: 'Refusée',
      withdrawn: 'Retirée',
      expired: 'Expirée',
    },
    myListing: 'Votre profil de coach',
    myListingExplainer:
      'Vous seul mettez ce profil dans la liste. C\'est indépendant de votre ' +
      'préférence de partage avec la communauté.',
    listingSaved: 'Profil de coach enregistré.',
    saveFailed: 'Le profil n\'a pas pu être enregistré.',
    headlineLabel: 'Description courte',
    bioLabel: 'À propos de vous',
    programmesLabel: 'Programmes que vous accompagnez',
    maxMembersLabel: 'Nombre maximal de personnes',
    maxMembersHelp_one: 'Vous accompagnez actuellement {{count}} personne.',
    maxMembersHelp_other: 'Vous accompagnez actuellement {{count}} personnes.',
    acceptingLabel: 'Ouvert à de nouvelles personnes',
    publishLabel: 'Proposer dans mon organisation',
    publishNeedsBoth:
      'Un profil listé a besoin d\'une description courte et de quelques mots ' +
      'sur vous : c\'est ce sur quoi on choisit.',

    peopleYouFollow: 'Personnes que vous accompagnez',
    peopleYouFollowExplainer:
      'Ce que vous pouvez voir de quelqu\'un, c\'est cette personne qui le décide.',

    directoryUnknown: 'La liste n\'a pas pu être lue',
    directoryUnknownNotice: 'Veuillez réessayer plus tard.',
    onlyYouListedTitle: 'Vous êtes le seul coach dans la liste',
    onlyYouListedNotice:
      'Aucun autre coach de votre organisation n’a encore publié de profil.',
    noneListedTitle: 'Aucun coach dans la liste pour l\'instant',
    noneListedNotice:
      'Dès qu\'un coach de votre organisation publie un profil, il apparaît ici.',
    canAsk: 'Coachs que vous pouvez solliciter',
    allAlreadyYoursTitle: 'Pas encore d\'autres coachs',
    allAlreadyYoursNotice: 'Les coachs qui vous accompagnent déjà sont listés ci-dessus. Tout autre coach de votre organisation apparaîtra ici dès qu\'il publiera un profil.',
    onlyAccepting: 'Seulement ceux qui accueillent de nouvelles personnes',
    search: 'Rechercher un coach',
    noneAcceptingTitle: 'Personne n\'accueille de nouvelles personnes',
    noneAcceptingNotice: 'Aucun des coachs de la liste n\'est ouvert à de nouvelles personnes en ce moment.',
    listingUnknownTitle: 'Votre profil de coach n\'a pas pu être lu',
    listingUnknown: 'Ce que vous voyez ici peut être obsolète.',
    noListingTitle: 'Vous n\'avez pas de profil de coach',
    noListing:
      'Sur cet écran, un coach modifie le profil que les membres voient. Votre compte n\'a pas de rôle de coach, il n\'y a donc rien à modifier ici pour le moment.',
    grantsUnknownTitle: 'Vos coachs n\'ont pas pu être lus',
    grantsUnknown: 'Ce que vous voyez ici peut être obsolète.',
    noneMatchTitle: 'Aucun coach trouvé',
    noneMatchNotice: 'Rien ne correspond à "{{query}}". Essayez une partie d\'un nom ou d\'un programme.',

    myCoaches: 'Vos coachs',
    changeOnCoaches:
      'Modifiez les mesures qu\'un coach peut voir sur la page des coachs.',
    whatTheyMaySee: 'Ce que ce coach peut voir',
    sinceExplainer:
      'Vous avez accordé cet accès le {{when}}. Les modifications prennent effet immédiatement.',
    saveAccess: 'Enregistrer les modifications',
    accessSaved: 'Modifications enregistrées.',
    accessSaveFailed: 'La modification n\'a pas pu être enregistrée.',
    keepOneOrEnd:
      'Gardez au moins une mesure, ou mettez plutôt fin à l\'accès — ainsi le coach en est informé.',
    nothingShared: 'Rien n\'est partagé avec ce coach.',
    accessEndedOn: 'Cet accès a pris fin le {{when}}.',
    offerUnreadable:
      'Les mesures de votre programme n\'ont pas pu être lues : seul ce qui est déjà partagé est listé.',
    endCoaching: 'Mettre fin à l\'accès',
    endCoachingTitle: 'Mettre fin à l\'accès',
    endCoachingBody:
      '{{name}} ne pourra plus voir vos mesures. Ce qui est déjà enregistré reste.',
    grantedOn: 'Accès accordé le {{when}}',
    endedCoaching: 'Accompagnement terminé',
    endedOn: 'Terminé le {{when}}',
    revokeFailed: 'L\'accès n\'a pas pu être arrêté.',

    tabs: {
      coaches: 'Mes coachs',
      history: 'Historique',
      listing: 'Mon profil de coach',
      requests: 'Demandes qui me sont faites',
      members: 'Personnes que j\'accompagne',
    },

    noProgrammeTitle: 'Vous ne suivez encore aucun programme',
    noProgrammeNotice: 'Un coach accompagne un programme. Dès que vous en suivez un, les coachs qui l\'accompagnent apparaissent ici.',
    noHistoryTitle: 'Rien à revoir pour l\'instant',
    noHistoryNotice: 'Les accompagnements terminés et les demandes restées sans suite sont conservés ici.',
    peopleYouCoached: 'Personnes que vous avez accompagnées',
    noPastMembersTitle: 'Personne n\'a arrêté',
    noPastMembersNotice: 'Toutes les personnes que vous accompagnez sont toujours là. Un accompagnement qui se termine est consigné ici.',
    noOpenRequestsTitle: 'Aucune demande en attente',
    noOpenRequestsNotice: 'Quand quelqu\'un vous demande de l\'accompagner, sa demande apparaît ici.',
    answeredRequests: 'Demandes traitées',
    noMembersYetTitle: 'Vous n\'accompagnez encore personne',
    noMembersYetNotice: 'Dès que quelqu\'un accepte votre demande, cette personne apparaît ici avec ce qu\'elle vous laisse voir.',
    memberUnreadableTitle: 'Ces mesures n\'ont pas pu être lues',
    memberUnreadable: 'Veuillez réessayer dans un instant.',
    nothingPermittedTitle: 'Rien à afficher',
    nothingPermittedNotice: 'Les programmes de cette personne ne comportent aucune mesure qui puisse vous être partagée.',
    nothingSharedWithYouTitle: 'Rien de partagé pour l\'instant',
    nothingSharedWithYouNotice: 'Cette personne ne vous a partagé aucune mesure. Ce qu\'elle pourrait partager est indiqué ci-dessous.',
    notShared: 'Non partagé avec vous',
    notSharedNotice: 'Cette personne n\'a pas partagé cette mesure, rien n\'est donc affiché à son sujet.',
    sourceUnavailable: 'La source n\'a pas répondu',
    sourceIncomplete: 'Partiellement illisible',
    sourceIncompleteNotice: 'Certaines valeurs envoyées par cette source ne sont pas lisibles, donc tout ne figure pas ici.',
    sourceSilent: 'La source qui conserve ces valeurs n\'a pas répondu',
    sourceRefused: 'Source illisible pour vous',
    sourceNotReadForYou: 'La source qui conserve ces valeurs ne peut pas être lue en votre nom',
    recordedHere: 'Enregistré sur cette plateforme',
    fromSourceAsOf: 'De {{source}}, consulté {{when}}',
    asOfUnknown: 'à un moment inconnu',
    mixedSources: 'Les valeurs proviennent de {{places}} sources différentes, aucune variation n\'est donc affichée.',
    sourcesDegradedTitle: 'Des valeurs peuvent manquer',
    sourcesDegraded: 'Aucune réponse de {{names}}. Les valeurs conservées là peuvent manquer sur cet écran.',
    sourcesRefusedTitle: 'Certaines valeurs ne peuvent pas être affichées',
    sourcesRefused: '{{names}} ne peut pas être lu en votre nom, les valeurs conservées là ne figurent donc pas sur cet écran. Il s\'agit de l\'accès entre cette source et cette plateforme, pas de ce que cette personne a partagé avec vous.',
    sourceNotConnectedChip: 'Non connecté',
    sourceNotConnectedCaption: 'Connectez votre propre compte pour lire les valeurs conservées dans cette source',
    sourcesNotConnectedTitle: 'Connectez-vous pour lire certaines valeurs',
    sourceNotConnected: '{{name}} ne peut être lu qu\'avec votre propre compte. Connectez-le une fois, et les valeurs que cette personne a partagées avec vous pourront s\'afficher ici.',
    sourceReconnect: 'Votre connexion à {{name}} a pris fin, les valeurs conservées là ne figurent donc pas sur cet écran. Reconnectez-vous pour lire ce que cette personne a partagé avec vous.',
    connectSource: 'Connecter {{name}}',
    reconnectSource: 'Reconnecter {{name}}',
    connectedTitle: 'Connecté à {{source}}',
    connectedBody: 'Rouvrez cette personne pour lire les valeurs partagées.',
    connectFailedTitle: 'La connexion n\'a pas pu être établie',
    connectFailedBody: 'Rien n\'a été modifié. Réessayez plus tard.',
    notConnectedTitle: 'Non connecté à {{source}}',
    connectReasons: {
      refused: '{{source}} n\'a pas accepté la connexion, rien n\'a donc été connecté.',
      no_code: 'La connexion à {{source}} n\'a rien renvoyé, rien n\'a donc été connecté.',
      no_party_id: 'Votre compte chez {{source}} ne porte pas encore d\'identifiant JLAM et ne peut donc pas vous nommer là-bas. Demandez à la personne qui gère les comptes.',
      no_person: 'Votre compte ici n\'est lié à aucune personne et ne peut donc pas être connecté.',
    },
    sourcesStaleTitle: 'Certaines valeurs peuvent être périmées',
    sourcesStale: 'Aucune actualisation possible pour {{names}}. Ce qui y a été enregistré depuis la dernière vérification manque sur cet écran.',
    withheldFromHistory: 'Non partagé avec vous : {{names}}',
    source: 'Source',
    asOf: 'Consulté',
    here: 'Cette plateforme',
    lastRecorded: 'Dernier relevé le {{when}}',
    lastRecordedByYou: 'Dernier relevé saisi par vous le {{when}}',
    noReadingYet: 'Aucune valeur enregistrée',
    readOnlyHere: 'Consultation seule',
    newValue: 'Nouvelle valeur',
    unit: 'Unité',
    measuredAt: 'Mesuré le',
    momentInFuture: 'Une mesure ne peut pas être datée dans le futur.',
    recordedSome_one: '{{count}} valeur enregistrée ; le reste non.',
    recordedSome_other: '{{count}} valeurs enregistrées ; le reste non.',
    record: 'Enregistrer',
    recorded_one: '{{count}} valeur enregistrée.',
    recorded_other: '{{count}} valeurs enregistrées.',
    recordFailed: 'La valeur n\'a pas pu être enregistrée.',
    nothingToRecord: 'Saisissez d\'abord une valeur.',
    valueNotANumber: 'Cette mesure attend un nombre.',
    requestSent: 'Demande envoyée à {{name}}.',
    requestAccepted: 'Vous accompagnez maintenant {{name}}.',
    requestDeclined: 'Demande de {{name}} refusée.',
    requestWithdrawn: 'Demande à {{name}} retirée.',
    accessEnded: '{{name}} ne peut plus voir vos mesures.',
    findSomeoneYouCoach: 'Chercher une personne que vous accompagnez',
    personColumn: 'Personne',
    sinceColumn: 'Depuis',
    trendColumn: 'Tendance',
    lastActivityColumn: 'Dernier relevé',
    lastActivityNever: 'Rien d’enregistré',
    lastActivityOn: 'Dernier relevé le {{when}}',
    searchMembers: 'Rechercher parmi les personnes que vous accompagnez',
    noMatchesTitle: 'Personne ne correspond',
    noMatchesNotice: 'Essayez une recherche plus courte, ou videz le champ.',
    openMember: 'Ouvrir {{name}}',
    caseloadUnknownTitle: 'Les personnes que vous accompagnez n’ont pas pu être lues',
    caseloadUnknownNotice: 'Veuillez réessayer dans un instant.',
    jumpToAnother: 'Aller à une autre personne',
    memberNotInCaseloadTitle: 'Pas une personne que vous accompagnez',
    memberNotInCaseloadNotice: 'Cette personne ne figure pas dans votre liste. L’accompagnement a peut-être pris fin, ou le lien est ancien.',
    trendNothing: 'Rien de partagé',
    trendInRange_one: '{{count}} dans la plage',
    trendInRange_other: '{{count}} dans la plage',
    trendToward_one: '{{count}} se rapproche de la cible',
    trendToward_other: '{{count}} se rapprochent de la cible',
    trendAway_one: '{{count}} s’éloigne de la cible',
    trendAway_other: '{{count}} s’éloignent de la cible',
    trendTracked_one: '{{count}} mesure suivie',
    trendTracked_other: '{{count}} mesures suivies',
    coachingSince: 'Accompagnement depuis le {{when}}',
    viewTrends: 'Tendances',
    viewHistory: 'Historique',
    recordedAt: 'Enregistré',
    value: 'Valeur',
    recordedBy: 'Enregistré par',
    you: 'Vous',
    noReadingsTitle: 'Rien d\'enregistré pour l\'instant',
    noReadingsNotice: 'Les valeurs enregistrées pour cette personne apparaissent ici, les plus récentes d\'abord.',
  },
  manageRoles: {
    noTenantNotice: 'Les rôles appartiennent à une organisation, et ce compte n’appartient à aucune.',
    noTenantTitle: 'Aucune organisation dont montrer les rôles',
  },
  look: {
    title: 'Symbole et couleurs',
    symbol: {
      title: 'Symbole',
      description: 'Affiché à chaque membre à côté du nom du tenant dans la barre de navigation. Il appartient à l’organisation, donc tous ses tenants affichent le même symbole.',
      preview: 'Ainsi se place le symbole dans la barre de navigation',
      none: 'Pas encore de symbole. Les membres voient seulement le nom du tenant.',
      accepted: 'PNG ou WebP, 512 Ko au plus et au moins 64 × 64 pixels.',
      choose: 'Choisir une image',
      save: 'Enregistrer le symbole',
      saved: 'Symbole enregistré.',
      remove: 'Retirer le symbole',
      removed: 'Symbole retiré.',
      refused: 'Ce fichier ne peut pas être utilisé. Choisissez une image PNG ou WebP de 512 Ko au plus et d’au moins 64 × 64 pixels.',
      error: 'Le symbole n’a pas pu être enregistré. Réessayez.',
    },
    profiles: {
      title: 'Profils de couleurs',
      description: 'Les membres voient le profil par défaut jusqu’à ce qu’ils en choisissent un. Les profils standard de MLP sont toujours proposés à côté des vôtres.',
      standard: 'Profil standard de MLP',
      own: 'Profil de ce tenant',
      default: 'Par défaut',
      makeDefault: 'Définir par défaut',
      defaultSaved: '{{name}} est désormais le profil par défaut.',
      edit: 'Modifier les couleurs',
      history: 'Historique',
      add: 'Ajouter un profil',
      newName: 'Nom du profil',
      create: 'Enregistrer le profil',
      added: '{{name}} a été ajouté en version 1.',
      duplicateName: 'Ce tenant a déjà un profil portant ce nom. Choisissez un autre nom.',
      loadError: 'Les profils de couleurs n’ont pas pu être chargés. Rechargez la page pour réessayer.',
      saveError: 'La modification n’a pas pu être enregistrée. Réessayez.',
    },
    editor: {
      title: 'Couleurs de {{name}}',
      newTitle: 'Nouveau profil de couleurs',
      hexLabel: 'Valeur hexadécimale de {{role}}',
      variants: 'Variante plus claire, principale et plus foncée, avec la couleur du texte sur la principale',
      textSample: 'Aa',
      contrastIntro: 'Avec ces couleurs, le texte serait difficile à lire. Modifiez la couleur indiquée ci-dessous :',
      contrastFailure: '{{role}}, {{pairing}} : {{ratio}}:1, alors qu’il faut au moins {{required}}:1',
      pairing: {
        textOnColour: 'texte sur cette couleur',
        linkOnPaper: 'en texte de lien sur blanc',
        linkOnPage: 'en texte de lien sur le fond de la page',
      },
      save: 'Enregistrer comme nouvelle version',
      saved: 'Enregistré en version {{version}}.',
      reset: 'Revenir à Meridian',
      close: 'Fermer',
    },
    history: {
      title: 'Historique de {{name}}',
      version: 'Version {{version}}',
      savedBy: '{{when}}, par {{who}}',
      savedAt: '{{when}}',
      current: 'En vigueur',
      rollBack: 'Revenir à cette version',
      rolledBack: 'Rétabli. Enregistré en version {{version}}.',
      loadError: 'L’historique n’a pas pu être chargé.',
      rollBackError: 'Le rétablissement n’a pas pu être enregistré. Réessayez.',
    },
    preview: {
      title: 'Aperçu',
      navigationCurrent: 'Tableau de bord',
      navigationOther: 'Mesures',
      button: 'Enregistrer',
      secondButton: 'Ajouter',
      link: 'Un lien',
      chart: 'Une mesure sur une semaine, avec sa plage cible',
    },
    roles: {
      primary: {
        name: 'Couleur principale',
        hint: 'Navigation, boutons, liens et focus',
      },
      secondary: {
        name: 'Deuxième couleur',
        hint: 'Boutons secondaires et mises en avant',
      },
      success: {
        name: 'Dans la plage',
        hint: 'Une valeur là où elle doit être, et ce qui a réussi',
      },
      warning: {
        name: 'Hors plage',
        hint: 'Une valeur qui s’écarte de sa cible',
      },
      error: {
        name: 'Erreur',
        hint: 'Erreurs, et ce qui demande de l’attention maintenant',
      },
      info: {
        name: 'Information',
        hint: 'Avis neutres',
      },
    },
    standard: {
      meridian: 'Meridian',
      lagune: 'Lagon',
      classic: 'Classique',
    },
    choice: {
      title: 'Profil de couleurs',
      description: 'L’apparence de l’application pour vous. Votre choix s’applique dès que vous enregistrez votre profil et vous suit sur vos autres appareils.',
      followTenant: 'Par défaut de {{tenant}} ({{name}})',
      followMeridian: 'Par défaut de MLP (Meridian)',
      loadError: 'Les profils de couleurs n’ont pas pu être chargés.',
    },
  },
  valueDetail: {
    title: 'D\'où vient cette valeur',
    traceTitle: 'Trace de cette valeur',
    loading: 'Lecture de l\'origine de cette valeur',
    missing: 'Il n\'y a aucune valeur avec ce numéro.',
    failed: 'L\'origine de cette valeur n\'a pas pu être lue.',
    retry: 'Réessayer',
    value: 'Valeur',
    time: 'Moment',
    notKnown: 'On n\'en sait pas plus sur cette valeur.',
    recorded: 'Tel qu\'enregistré',
    code: 'Code',
    codeSystem: 'Système de codes : {{system}}',
    source: 'Source',
    sources: {
      manualInput: 'Saisi par toi',
      deviceSync: 'D\'une source connectée',
      uploaded: 'D\'un document',
      coachingSession: 'D\'un coach',
    },
    shownAs: 'Affiché comme',
    converted: 'Comment elle a été convertie',
    noConversion: 'Pas de conversion : affiché tel qu\'enregistré.',
    conversion: {
      algebra: '1 {{from}} = {{factor}} {{to}}, confirmé le {{date}}.',
      molarMass: '1 {{from}} = {{factor}} {{to}}, via la masse molaire de {{analyte}} ({{mass}} g/mol, source : {{source}}), confirmé le {{date}}.',
    },
    reference: 'Référence',
    changedSince: 'Modifié depuis',
    notChanged: 'Le code n\'a pas changé depuis.',
    laterRelease: 'Une version ultérieure a modifié ce code après l\'enregistrement de la valeur.',
    change: '{{field}} : {{from}} → {{to}} ({{date}})',
    showFullOrigin: 'Afficher l\'origine complète',
    close: 'Fermer',
    graphLabel: 'Mesures. Utilise les touches fléchées pour passer de l\'une à l\'autre.',
    graphOpenHint: 'Appuie sur Entrée pour l\'ouvrir.',
  },
  groupingLevels: {
    label: 'Jusqu\'où les valeurs comptent',
    loading: 'Lecture des niveaux',
    loadFailed: 'Les niveaux n\'ont pas pu être lus. Le niveau enregistré reste inchangé.',
    THIS_CODE: {
      name: 'Ce code uniquement',
      help: 'Seules comptent les valeurs enregistrées sous ce code exact.',
    },
    ANY_METHOD: {
      name: 'La même chose, quelle que soit la méthode',
      help: 'Les valeurs de la même chose comptent, qu\'elles soient mesurées à la maison ou en clinique.',
    },
  },
};

export default { translation };
